import { forwardRef, useMemo } from 'react';
import { format } from 'date-fns';
import { Datepicker } from '@mobiscroll/react';
import Skeleton from 'react-loading-skeleton';
import {
  FORMAT_QT_DATE,
  FORMAT_WEEKDAY_DATE_YEAR_MOBI,
} from 'utils/helpers/datetime';

// For range calendars on mobile, please consider using `onTempChange` to avoid the potential issues
// https://bitbucket.org/team-sealink/stg-website-platform/pull-requests/2771
function Calendar(props, ref) {
  const min = useMemo(() => format(new Date(), FORMAT_QT_DATE), []);

  // All the available options - https://docs.mobiscroll.com/react/datepicker#options
  const defaultProps = {
    select: 'date',
    inputComponent: 'input',
    dateFormat: FORMAT_WEEKDAY_DATE_YEAR_MOBI,
    inRangeInvalid: false,
    rangeEndInvalid: false,
    showOuterDays: false,
    showRangeLabels: false,
    // Set it to null to avoid potential issues on mobile
    // https://bitbucket.org/team-sealink/stg-website-platform/pull-requests/2766
    defaultSelection: null,
    themeVariant: 'light',
    cssClass: 'mobiscroll-sealink',
    setText: 'Done',
    min,
  };
  const processedProps = {
    ...defaultProps,
    ...props,
  };

  if (processedProps.loading) {
    processedProps.renderDay = () => <Skeleton height="2rem" />;
  }

  return (
    <Datepicker
      ref={ref}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...processedProps}
    />
  );
}

const forwaredCalendar = forwardRef(Calendar);

export default forwaredCalendar;
